// extracted by mini-css-extract-plugin
export default {"root_scroller":"k1","flex_container":"l1","container":"m1","scroller":"n1","indicator":"o1","scrollButtons":"p1","selected":"q1","root_tab":"r1","root_tab_scrollable":"s1","root_scroller_mob":"t1","scroller_mob":"u1","indicator_mob":"v1","selected_mob":"w1","root_tab_mob":"x1","root_tab_mob_scrollable":"y1"};
    if(module.hot) {
      // 1715632479232
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  